export const ROLES = Object.freeze({
  ADMIN: 'admin',
  GUEST: 'guest',
});
